import * as Immutable from "immutable";
import { createSelector } from "@reduxjs/toolkit";
import { useMemo } from "react";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectSearchQueries } from "views/logic/slices/viewSelectors";
const selectQueriesAsMap = createSelector(
  selectSearchQueries,
  (queries) => Immutable.OrderedMap(queries.map((q) => [q.id, q]))
);
const useQueries = () => useViewsSelector(selectQueriesAsMap);
const useQueryFilters = () => {
  const queries = useQueries();
  return useMemo(() => queries.map((q) => q.filter).toMap(), [queries]);
};
export default useQueryFilters;
